import { Navigate, Outlet } from "react-router-dom";

const ChangeDirectRoute = ({ auth, to = "/", children }) => {
  if (auth === false) {
    return <Navigate to={to} replace={true} />;
  }

  return children ? children : <Outlet />;
};

export default ChangeDirectRoute;
